import React, { useRef, useState } from "react";
import axios from "axios";

import lbnlogo from '../Images/lbnlogo.jpeg';

const VisitorForm = () => {
    //   const [form, setForm] = useState({
    //     name: "",
    //     company: "",
    //     category: "",
    //     phone: "",
    //     email: "",
    //     invitedBy: "",
    //     paymentDetails: "",
    //     invitation: null,
    //   });

    //   const handleChange = (e) => {
    //     if (e.target.name === "invitation") {
    //       setForm({ ...form, invitation: e.target.files[0] });
    //     } else {
    //       setForm({ ...form, [e.target.name]: e.target.value });
    //     }
    //   };

    //   const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const data = new FormData();
    //     Object.keys(form).forEach((key) => {
    //       data.append(key, form[key]);
    //     });

    //     try {
    //       await axios.post("https://api.lbnhyderabad.com/api/register", data);
    //       alert("Registered Successfully!");
    //     } catch (err) {
    //       console.error(err);
    //       alert("Error submitting form");
    //     }
    //   };

    //   const styles = {
    //     container: {
    //       maxWidth: "600px",
    //       margin: "20px auto",
    //       padding: "20px",
    //       borderRadius: "12px",
    //       boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    //       fontFamily: "Arial",
    //       background: "#fff",
    //     },
    //     logo: {
    //       textAlign: "center",
    //       marginBottom: "15px",
    //       fontSize: "22px",
    //       fontWeight: "bold",
    //       color: "#2c3e50",
    //     },
    //     input: {
    //       width: "100%",
    //       padding: "10px",
    //       marginBottom: "10px",
    //       borderRadius: "8px",
    //       border: "1px solid #ccc",
    //     },
    //     button: {
    //       width: "100%",
    //       padding: "12px",
    //       border: "none",
    //       borderRadius: "8px",
    //       background: "#007bff",
    //       color: "#fff",
    //       fontSize: "16px",
    //       cursor: "pointer",
    //     },
    //     schedule: {
    //       marginTop: "20px",
    //       fontSize: "14px",
    //       lineHeight: "1.6",
    //     },
    //   };
    const [form, setForm] = useState({
        name: "",
        company: "",
        category: "",
        phone: "",
        email: "",
        invitedBy: "",
        paymentDetails: "",
        invitation: null,
    });

    const handleChangeVF = (e) => {
        if (e.target.name === "invitation") {
            setForm({ ...form, invitation: e.target.files[0] });
        } else {
            setForm({ ...form, [e.target.name]: e.target.value });
        }
    };

    // const handleSubmitVF = async (e) => {
    //   e.preventDefault();

    // const data = new FormData();
    // Object.keys(form).forEach((key) => {
    //   data.append(key, form[key]);
    // });

    //   try {
    //     await axios.post("http://localhost:10005/signup/api/register", data);
    //     alert("Registered Successfully!");
    //   } catch (err) {
    //     console.error(err);
    //     alert("Error submitting form");
    //   }
    // };

    const formRef = useRef(null);

    const handleSubmitVF = async (e) => {
        e.preventDefault();

        // const userId = sessionStorage.getItem('userId'); // ✅ get userId

        // const data = new FormData();

        // Object.keys(form).forEach((key) => {
        //   if (key === "invitedBy") {
        //     data.append("invitedBy", userId); // ✅ override here
        //   } else {
        //     data.append(key, form[key]);
        //   }
        // });
        const data = new FormData();
        Object.keys(form).forEach((key) => {
            data.append(key, form[key]);
        });

        try {
            await axios.post("https://api.lbnhyderabad.com/signup/api/register", data);
            alert("Registered Successfully!");

            if (formRef.current) {
                formRef.current.reset();
            }
            // ✅ CLEAR FORM
            setForm({
                name: "",
                company: "",
                category: "",
                phone: "",
                email: "",
                paymentDetails: "",

            });

        } catch (err) {
            console.error(err);
            alert("Error submitting form");
        }
    };

    const styles = {
        container: {
            maxWidth: "600px",
            margin: "20px auto",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            fontFamily: "Arial",
            background: "#fff",
        },
        logo: {
            textAlign: "center",
            marginBottom: "15px",
            fontSize: "22px",
            fontWeight: "bold",
            color: "#2c3e50",
        },
        input: {
            width: "100%",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
        },
        button: {
            width: "100%",
            padding: "12px",
            border: "none",
            borderRadius: "8px",
            background: "#007bff",
            color: "#fff",
            fontSize: "16px",
            cursor: "pointer",
        },
        schedule: {
            marginTop: "20px",
            fontSize: "14px",
            lineHeight: "1.6",
        },
        header: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
            background: "#fff",
        },

        logoImg: {
            height: "150px",
            width: "200px",
            objectFit: "contain",
        },

        titleBar: {
            background: "#007bff",
            
            color: "#fff",
            textAlign: "center",
            padding: "10px",
            fontSize: "18px",
            fontWeight: "bold",
            borderRadius: "8px 8px 0 0",
        },

        footer: {
            marginTop: "20px",
            textAlign: "center",
            padding: "10px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "0 0 8px 8px",
            fontWeight: "bold",
        },
    };



    return (
        <>
            <div style={styles.header}>
                <img src={lbnlogo} alt="LBN Logo" style={styles.logoImg} />
            </div>
            {/* 
            <div style={styles.container}>
                <div style={styles.titleBar}>
                    Visitor Registration Form
                </div> */}
            <div style={styles.container}>

                <div style={styles.logo}>  Visitor Registration Form</div>

                <form ref={formRef} onSubmit={handleSubmitVF}>
                    <input name="name" placeholder="Name" style={styles.input} onChange={handleChangeVF} required />
                    <input name="company" placeholder="Business / Company Name" style={styles.input} onChange={handleChangeVF} />
                    <input name="category" placeholder="Business Category" style={styles.input} onChange={handleChangeVF} />
                    <input name="phone" placeholder="Contact Number" style={styles.input} onChange={handleChangeVF} required />
                    <input name="email" placeholder="Email" style={styles.input} onChange={handleChangeVF} required />
                    <input name="invitedBy" placeholder="Invited By" style={styles.input} onChange={handleChangeVF} />
                    <input name="paymentDetails" placeholder="Payment Details" style={styles.input} onChange={handleChangeVF} />

                    {/* <input type="file" name="invitation" style={styles.input} onChange={handleChangeVF} /> */}

                    <button style={styles.button}>Register</button>
                </form>

                <div style={styles.schedule}>
                    <strong>Meeting Schedule</strong><br />
                    7:30 AM – 8:00 AM Networking<br />
                    8:00 AM – 9:30 AM Business Meeting<br />
                    9:30 AM Breakfast & Networking<br /><br />
                    Carry 100+ Visiting Cards<br /><br />
                    <b>Happy Networking</b><br />
                    Team - LBN
                </div>
            </div>
            <div style={styles.footer}>
                LBN - MD320
            </div>

        </>
    );
};

export default VisitorForm;